// Url paths:
export const personalLinkedIn = "https://www.linkedin.com/in/mauro-silva18"
export const personalGitHub = "https://github.com/MauroSilva17"
export const endlesslinkedIn = 'https://www.linkedin.com/company/endlessds/'